<template>
  <div class="form-group lm-text-area" v-if="isVisible" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}}
      <small v-if="required">*</small>
    </label>
    <font-awesome-icon
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <textarea
        :autofocus="autofocus"
        ref="textarea"
        :value="value"
        @focusout="validateOnfocusOutMethod"
        @input="$emit('input', $event.target.value)"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        class="form-control"
        :id="idComputed"
        :rows="rows"
        :cols="cols"
        :disabled="disabled"
        :maxlength="maxLength"
        ></textarea>
        <p class="invalid-feedback" v-if="v.required === false"> {{ $t('field_required')}} </p>
        <p class="invalid-feedback" v-if="v.maxLength === false"> {{ $tc('character_max_length', maxLengthCharactersAllowed )}} </p>
        <p id="lm-text-area-was-max-length-reached" v-if="wasMaxLengthReached"> {{ $t('max_length_reached' )}} </p>
        <p class="invalid-feedback" v-if="v.sameAs !== undefined && !v.sameAs"> {{ $t('field_same_as') + labelOfFieldUsedForsameAsValidation }}</p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  props: {
    rows: {
      type: String,
      default: '3'
    },
    cols: {
      type: String,
      default: '20'
    },
    maxLength: {
      type: Number,
      default: 512
    }
  }
}
</script>
